import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    cardAnnouncement: {
      display: 'flex',
      flexDirection: 'row'
    },
    actionAnnouncement: {
      // marginRight: theme.spacing(2)
    }
  })
